import { render, staticRenderFns } from "./SectionComments.vue?vue&type=template&id=98d7d4e4&"
import script from "./SectionComments.vue?vue&type=script&lang=ts&"
export * from "./SectionComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports